import $ from "jquery";
import axios from 'axios';

export const showTestResult = () => {
    $(document).on('click', '.test-answer', function () {
        const thisAnswer = $(this);
        const testAnswerParent = thisAnswer.parent('.test-answers');
        const testAnswers = testAnswerParent.find('.test-answer');
        let isAnswered = false;

        testAnswers.each(function () {
            if ($(this).is('.test-answer--wrong') || $(this).is('.test-answer--correct')) {
                isAnswered = true;
            }
        });

        if (isAnswered) {
            return;
        }

        axios.get(testAnswerParent.data('url') + '?answerId=' + thisAnswer.attr('data-id'))
            .then((response) => {
                const currentId = parseInt(thisAnswer.attr('data-id'));

                if (!response && !response.data) {
                    return;
                }

                response.data.forEach(function callback(answer, index, array) {
                    const answerElement = thisAnswer.parent().find('[data-id=' + answer.id + ']');
                    answerElement.find('.test-answer__percent').text(answer.answeredPercent + '%');
                    answerElement.parents('.content-test-question').find('.test-page-button').css('display', 'flex');

                    if (answer.id === currentId && !answer.isCorrect) {
                        thisAnswer.addClass('test-answer--wrong');
                        answerElement.find('.test-answer__comment-text').text(answer.description);

                        if (answer.imageUrl !== null) {
                            answerElement.find('.test-image--answer img').attr('src', answer.imageUrl);
                            answerElement.find('.test-image__source').html(getSourceName(
                                answer.imageAuthorName,
                                answer.imgSource
                            ));
                            answerElement.find('.test-image--answer').show();
                        }
                    }

                    if (answer.isCorrect) {
                        answerElement.addClass('test-answer--correct');
                        answerElement.find('.test-answer__comment-text').text(answer.description);

                        if (answer.imageUrl !== null) {
                            answerElement.find('.test-image--answer img').attr('src', answer.imageUrl);
                            answerElement.find('.test-image__source').html(getSourceName(
                                answer.imageAuthorName,
                                answer.imgSource
                            ));
                            answerElement.find('.test-image--answer').show();
                        }

                        answerElement.find('.test-answer__comment').show();
                    }
                });
            });


        if ($('.test-answer__comment').length > 0) {
            thisAnswer.find('.test-answer__comment').show();
        }

        testAnswers.each(function () {
            thisAnswer.addClass('test-answer--result');
        })
    });
};

const getSourceName = (authorName, sourceName) => {
    const sourceTextList = [];

    if (authorName) {
        sourceTextList.push(authorName);
    }

    if (sourceName) {
        sourceTextList.push(`<a href="${sourceName}" target="_blank">${sourceName}</a>`);
    }

    return sourceTextList.join(' / ');
};
